<template>
  <div>
    <WobbleHeart v-if="showWobbleHeart" />
    <div class="swiper-wrapper">
      <swiper
        ref="mySwiper"
        class="swiper"
        :options="swiperOption"
        @click-slide="handleClickSlide"
        @slideChange="handleChangeSlide"
        @slideChangeTransitionEnd="handleSlideChangeTransitionEnd"
      >
        <div
          id="swiper-pagination-swipe-card-stack"
          class="swiper-pagination"
          slot="pagination"
        />
        <LastCard
          v-if="done"
          :stackLength="allCards.length"
          :boxId="box.data.id"
          :firstCardId="allCards[0].id"
          @redoBox="redoBox"
        />
        <template v-else>
          <swiper-slide
            v-for="(card, index) in cards"
            :key="`card-slides-${index}`"
          >
            <SwipeCard
              :card="card"
              :isCurrent="currentActiveIndex == index"
              style="padding-top:30px;"
              v-if="shouldShowCard(index)"
            />
          </swiper-slide>
        </template>
      </swiper>
      <van-action-sheet
        v-model="showFeedbackForm"
        :title="$t('report issue')"
        :round="false"
      >
        <FeedbackForm
          :currentCardId="currentCardId"
          @feedbackdone="feedbackdone"
        />
      </van-action-sheet>
      <van-action-sheet
        v-model="showEditCardForm"
        :title="$t('edit card')"
        :round="false"
      >
        <CardForm
          :currentCard="cards[currentActiveIndex]"
          v-on:cardFormSubmitted="showEditCardForm = false"
        />
      </van-action-sheet>
    </div>

    <div class="btns-wrapper" v-if="!done">
      <div class="large-circle-btn" @click="showShare = true">
        <i class="fas fa-sliders-h green"></i>
      </div>
      <div
        class="large-circle-btn"
        @click="submitAddToFav"
        v-if="box.data.box_type != 'FAV'"
      >
        <i class="fas fa-heart red" v-if="alreadyFaved"></i>
        <i class="far fa-heart red" v-else></i>
      </div>
      <div class="large-circle-btn" @click="flipCard">
        <i class="fas fa-sync blue"></i>
      </div>
    </div>
    <van-action-sheet
      v-model="showShare"
      :cancel-text="$t('cancel')"
      :round="false"
    >
      <div class="content">
        <van-cell
          v-for="item in options"
          :key="item.name"
          @click="handleAction(item.action)"
        >
          <i :class="item.icon" :style="`color: ${item.color}`"></i>
          {{ $t(item.name) }}
        </van-cell>
      </div>
    </van-action-sheet>
    <van-action-sheet
      v-model="showSettings"
      :title="`${$t('card settings')}`"
      :round="false"
    >
      <Settings />
    </van-action-sheet>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { mapGetters, mapState } from "vuex";
import SwipeCard from "@/components/SwipeCard";
import LastCard from "@/components/box/LastCard";
import FeedbackForm from "@/components/FeedbackForm";
import WobbleHeart from "@/components/WobbleHeart";
import CardForm from "@/components/CardForm";
import Settings from "@/components/Settings";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "SwipeCardStack",
  components: {
    LastCard,
    Settings,
    SwipeCard,
    Swiper,
    SwiperSlide,
    FeedbackForm,
    CardForm,
    WobbleHeart
  },
  computed: {
    ...mapState("vokabel", ["box", "favBox"]),
    // ...mapGetters("vokabel", ["canEditBox", "cards"]),
    ...mapGetters("vokabel", { canEditBox: "canEditBox", allCards: "cards" }),
    cards() {
      // work around for now
      return this.allCards.concat([{ dummy: true }]);
    },
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    alreadyFaved() {
      const { favBox, cards, currentActiveIndex } = this;
      return favBox.includes(cards[currentActiveIndex].id) ? true : false;
    }
  },
  data() {
    return {
      done: false,
      showSettings: false,
      slideChange: false,
      showWobbleHeart: false,
      currentActiveIndex: 0,
      showFeedbackForm: false,
      showEditCardForm: false,
      showShare: false,
      currentCardId: null,
      options: [
        // {
        //   action: "fav",
        //   name: "add to my favorite",
        //   icon: "fas fa-heart",
        //   color: "#fa5269"
        // },
        // {
        //   action: "upload",
        //   name: "upload personal image",
        //   icon: "far fa-image"
        // },
        {
          action: "settings",
          name: "change card settings",
          icon: "fas fa-cog"
        },
        {
          action: "hide",
          name: "don't show card anymore",
          icon: "fas fa-eye-slash"
        },
        {
          action: "reportProblems",
          name: "report problems",
          icon: "fas fa-flag"
        }
      ],
      swiperOption: {
        initialSlide: 0,
        slideToClickedSlide: true,
        preventClicksPropagation: false,
        preventClicks: false,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 20,
        grabCursor: true,
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
          clickable: true
        }
      }
    };
  },
  methods: {
    ...mapActions("vokabel", ["BoxStateUpdate", "HideCard", "addToFavBox"]),
    ...mapMutations("setting", ["CLOSE_ZEN_MODE"]),
    redoBox() {
      this.done = false;
      this.swiper.slideTo(0);
    },
    shouldShowCard(index) {
      // if (index == this.currentActiveIndex - 1) {
      //   return true;
      // }
      // if (index == this.currentActiveIndex + 1) {
      //   return true;
      // }
      return index == this.currentActiveIndex;
    },
    handleAction(action) {
      this.showShare = false;
      this.currentCardId = this.cards[this.swiper.activeIndex].id;
      if (action == "fav") {
        this.submitAddToFav();
      }
      // if (action == "upload") {

      // }
      if (action == "editCard") {
        this.showEditCardForm = true;
      }

      if (action == "settings") {
        this.showSettings = true;
      }

      if (action == "hide") {
        const { cards, currentCardId, HideCard } = this;
        // has next card
        if (cards.length > this.swiper.activeIndex + 1) {
          HideCard({
            cardId: currentCardId,
            nextCardId: cards[this.swiper.activeIndex + 1].id,
            boxId: this.box.data.id
          });
        } else if (cards.length == 1) {
          // dont have next card wrap back to card 1
          HideCard({
            cardId: currentCardId,
            nextCardId: null,
            boxId: this.box.data.id
          });
        } else {
          // the only card in dec
          HideCard({
            cardId: currentCardId,
            nextCardId: cards[0].id,
            boxId: this.box.data.id
          });
        }
      }

      if (action == "reportProblems") {
        this.showFeedbackForm = true;
      }
    },
    handleClickSlide() {
      if (!this.slideChange) {
        this.flipCard();
      }
    },
    handleSlideChangeTransitionEnd() {
      this.slideChange = false;
    },
    handleChangeSlide() {
      // this is a workaround so the flip doesnt fire when the user swipes left right on desktop
      this.slideChange = true;
      // setTimeout(() => (this.slideChange = false), 300);
      this.currentActiveIndex = this.swiper.activeIndex;
      if (this.currentActiveIndex == this.allCards.length) {
        this.done = true;
      } else {
        this.BoxStateUpdate({
          cardId: this.cards[this.swiper.activeIndex].id,
          boxId: this.box.data.id
        });
      }
    },
    reportProblems() {},
    submitAddToFav() {
      this.showWobbleHeart = true;
      setTimeout(() => (this.showWobbleHeart = false), 1000);
      this.currentCardId = this.cards[this.swiper.activeIndex].id;
      this.addToFavBox(this.currentCardId);
    },
    flipCard() {
      const front =
        this.cards[this.swiper.activeIndex].front != undefined
          ? !this.cards[this.swiper.activeIndex].front
          : false;
      this.$set(this.cards[this.swiper.activeIndex], "front", front);
    },
    feedbackdone() {
      this.showFeedbackForm = false;
    },
    getInitialCardIndex() {
      const { cards } = this;
      const { data } = this.box;
      let lastSeenCardId = data.progress ? data.progress.last_seen_card : null;
      // if last seen card is not hide just return the correct index from the filtered card list
      if (lastSeenCardId) {
        for (let i = 0; i < cards.length; i++) {
          if (cards[i].id == lastSeenCardId) {
            return i;
          }
        }
      }
      return 0;
    }
  },
  created() {
    this.currentActiveIndex = this.getInitialCardIndex();
    this.swiperOption.initialSlide = this.currentActiveIndex;
    if (this.canEditBox) {
      this.options.splice(1, 0, {
        action: "editCard",
        name: "edit card",
        icon: "fas fa-pen-square"
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/styles.scss";
$font-size-huge: 1rem;
$white: #e3e3e3;
.swiper-wrapper {
}
.swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    font-size: $font-size-huge;
  }
}
.swiper-slide {
  width: 60%;
  min-width: 390px;
}
#swiper-pagination-swipe-card-stack.swiper-pagination-progressbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 90%;
  margin-left: 5%;
  top: 4px;
  height: 12px;
  box-shadow: 5px 0px 15px 0px #66bb6a;
  span.swiper-pagination-progressbar-fill {
    background: #66bb6a;
  }
}

.swiper-container-android .swiper-slide,
.swiper-wrapper {
  transform: none;
}

.van-cell__value--alone {
  text-align: left;
}

.btns-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  max-width: 300px;
  margin: auto;
  margin-top: 5px;
  z-index: 1000;
}
.large-circle-btn {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  i.green {
    color: $action-green;
    font-size: 1.2rem;
  }
  i.red {
    color: $action-red;
    font-size: 1.2rem;
  }
  i.yellow {
    color: $action-yellow;
    font-size: 1rem;
    transform: rotateY(180deg);
  }
  i.blue {
    color: $action-blue;
    font-size: 1rem;
  }
}
.small-circle-btn {
  height: 35px;
  width: 35px;
}
</style>
